import React, { FC } from 'react';
import { InventoryData } from '../../types/common';
import styles from './TcsoInventoryResult.module.css';
import { LinkButton } from '../common/button/LinkButton';

interface InventoryResultProps {
  inventoryData: InventoryData;
  retry: () => void;
}

export const TcsoInventoryResult: FC<InventoryResultProps> = ({ inventoryData, retry }) => {
  return (
    <>
      {inventoryData.state === 'SUCCESS' && (
        <div className="informationPanel" data-testid="inventory-result-success">
          <div>
            <p className="informationSubHeading m-b-4">Address</p>
            <div className="informationSectionText16 m-b-16">{inventoryData.address}</div>
          </div>
          <div className="m-b-12">
            <p className="informationSubHeading m-b-8">Comms hub device list</p>
          </div>
          {inventoryData.data.map(({ deviceId, deviceType, deviceStatus, smetsDeviceType }) => (
            <div key={deviceId} className="informationSection" data-testid={'inventory-check-device-' + deviceType}>
              <div className="informationSectionText16 bold m-b-4">{deviceType}</div>
              <div className="informationRow">
                {deviceStatus && (
                  <div>
                    <span className="informationSectionText16">{`Status: ${deviceStatus}`}</span>
                  </div>
                )}
                <div>
                  <span className="informationSectionText16">{`GUID: ${deviceId}`}</span>
                </div>
                <div>
                  <span className="informationSectionText16">{`Asset Type: ${smetsDeviceType}`}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {(inventoryData.state === 'FAIL' || inventoryData.state === 'PROCESSING') && (
        <div>
          <div className={styles.failScreenText}>
            <div className={styles.bodyTitleText}>Request timed out</div>
            <div className={styles.bodyText}>
              We couldn’t complete your request in time, please <LinkButton onClick={retry}>try again</LinkButton> or contact SST
            </div>
          </div>
        </div>
      )}
    </>
  );
};
